import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>About How To Bachelor</h4>
          <p>Your comprehensive guide to bachelor living. Master mental health, learn life skills, discover quick recipes, and start new hobbies. Welcome to your barbershop for life advice.</p>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/mental-health">Mental Health</Link></li>
            <li><Link to="/life-tips">Life Tips</Link></li>
            <li><Link to="/recipes">Recipes</Link></li>
            <li><Link to="/hobbies">Hobbies</Link></li>
            <li><Link to="/about">About</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Connect With Us</h4>
          <div className="social-links">
            <a href="https://www.instagram.com/howtobachelor/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">📷</a>
            <a href="https://twitter.com/HowToBachelor" target="_blank" rel="noopener noreferrer" aria-label="Twitter">🐦</a>
            <a href="https://www.youtube.com/channel/UC3brbCy2-6pQnkdgS0aZlsQ" target="_blank" rel="noopener noreferrer" aria-label="YouTube">📺</a>
          </div>
          <p style={{ marginTop: '1.5rem' }}>
            <Link to="/privacy">Privacy Policy</Link> •{' '}
            <Link to="/contact">Contact</Link>
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} How To Bachelor • howtobachelor.com • All rights reserved</p>
      </div>
    </footer>
  );
}

export default Footer;
